// Generated by CoffeeScript 2.7.0
var BASE_FIELDS, SettingsWechatPay;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import FieldList from 'trunks/vue/admin/components/response_fields/list/fieldable.js';

import AttachmentField from '../attachment_field.js';

BASE_FIELDS = [
  {
    id: -1,
    title: '商户号',
    key: 'mch_id',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  },
  {
    id: -2,
    title: 'App密钥',
    key: 'wxpay_key',
    type: 'Field::TextField',
    settings: {
      layout: null
    },
    _editing: true
  }
];

export default SettingsWechatPay = Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'field-list': FieldList,
    'attachment-field': AttachmentField
  },
  props: {
    activeTab: {
      type: String
    },
    wechatPayOptions: {
      type: Object
    }
  },
  data: function() {
    return {
      files: []
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <field-list :fields="baseAttributefields"
                :response="baseAttributeResponse"
                :entries="baseAttributeResponse.entries"
                :editing="true"
                extendClass="form-field-group field-list-two-item inline"
                ref="baseAttributesRef" />

    <div class="form-field-group inline">
      <attachment-field :attachment="attachment"
                        fieldTitle="商户证书"
                        requestUrl="/admin/settings/wechat_pay.json"
                        dataKey="wxpay_pkcs12" />
      <div class="form-field"></div>
    </div>

    <div class="content-footer">
      <button class="content-footer-btn" @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  computed: {
    attachment: function() {
      var file;
      if (this.wechatPayOptions.wxpay_pkcs12.url) {
        file = _.clone(this.wechatPayOptions.wxpay_pkcs12);
        file.filename = '已上传商户证书';
        return file;
      } else {
        return null;
      }
    },
    baseAttributefields: function() {
      return _.map(BASE_FIELDS, (item) => {
        return this._createTypeField(item);
      });
    },
    baseAttributeResponse: function() {
      return new Skylark.App.Model.Response({
        id: 'wechat_pay_response',
        entries: [
          {
            field_id: -1,
            value: this.wechatPayOptions.mch_id
          },
          {
            field_id: -2,
            value: this.wechatPayOptions.wxpay_key
          }
        ]
      });
    }
  },
  methods: {
    updateSettings: function() {
      if (!this.$refs.baseAttributesRef.getEntries()) {
        return;
      }
      return this.doRequest(this._transferEntries());
    },
    doRequest: function(data) {
      return Skylark.Libs.Ajax.patch('/admin/settings/wechat_pay.json', {
        data: data,
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function() {
          return Skylark.Bridge.newAlertify('更新失败', {
            type: 'danger'
          });
        }
      });
    },
    _transferEntries: function() {
      var data;
      data = {
        namespace: {}
      };
      _.each(BASE_FIELDS, (field) => {
        var entry;
        entry = _.find(this.$refs.baseAttributesRef.getEntries(), function(entry) {
          return entry.field_id === field.id;
        });
        if (entry) {
          return data.namespace[field.key] = entry.value;
        } else {
          return data.namespace[field.key] = '';
        }
      });
      return data;
    },
    _createTypeField: function(item) {
      return Skylark.App.Model.Field.Base.new(item, void 0, {});
    }
  }
});
